import { useMutation } from "@tanstack/react-query";
import { useAxios, useApiResponseParser } from "../";

export default function useUserRoles() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();

    function useListByUser() {
        return useMutation({
            mutationFn: (parameters: { UserId: string }) =>
                axiosPrivate.get(`/v1/user-roles/${parameters.UserId}`).then(parseSuccessResponseData),
        });
    }

    function useAssign() {
        return useMutation({
            mutationFn: (parameters: { UserId: string; RoleId: string }) =>
                axiosPrivate.post(`/v1/user-roles/assign`, parameters).then(parseSuccessResponseData),
        });
    }

    function useRemove() {
        return useMutation({
            mutationFn: (parameters: { UserId: string; RoleId: string }) =>
                axiosPrivate
                    .delete(`/v1/user-roles/${parameters.UserId}/${parameters.RoleId}`)
                    .then(parseSuccessResponseData),
        });
    }

    return { useListByUser, useAssign, useRemove };
}
